__turbopack_context__.v({
  "backgroundLogo": "staticHeader-module-scss-module__tSU_FG__backgroundLogo",
  "backgroundWrapper": "staticHeader-module-scss-module__tSU_FG__backgroundWrapper",
  "content": "staticHeader-module-scss-module__tSU_FG__content",
  "contentWrapper": "staticHeader-module-scss-module__tSU_FG__contentWrapper",
  "header": "staticHeader-module-scss-module__tSU_FG__header",
  "headerLogo": "staticHeader-module-scss-module__tSU_FG__headerLogo",
  "tagLine": "staticHeader-module-scss-module__tSU_FG__tagLine",
  "title": "staticHeader-module-scss-module__tSU_FG__title",
});
